import React from "react";

export const NETWORKS = [
  {
    id: "caro-renov",
    name: "CARO Rénov' — Rochefort Océan",
    logo: "/api/uploads/logo-rochefort-ocean.png",
    url: "https://www.agglo-rochefortocean.fr/les-artisans-rge",
    h: "h-12",
  },
  {
    id: "prre",
    name: "Plateforme Rochelaise de Rénovation Énergétique",
    logo: "/api/uploads/logo-prre.png",
    url: "https://prre.agglo-larochelle.fr/-/cabinet-echo",
    h: "h-12",
  },
  {
    id: "renov-info-service",
    name: "Rénov' Info Service — avec France Rénov'",
    logo: "/api/uploads/logo-renov-info-service.png",
    url: "https://renov-info-service.fr/annuaire-des-pros/",
    h: "h-9",
  },
];

export const NetworkBadges = ({ title }) => (
  <div className="mt-12 pt-8 border-t border-limestone/10" data-testid="footer-networks">
    <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-limestone/50 mb-5">{title}</p>
    <div className="flex flex-wrap gap-3">
      {NETWORKS.map((n) => (
        <a
          key={n.id}
          href={n.url}
          target="_blank"
          rel="noopener noreferrer"
          title={n.name}
          className="bg-limestone px-5 py-3 flex items-center border border-limestone/20 hover:border-terracotta transition-colors group"
          data-testid={`network-badge-${n.id}`}
        >
          <img
            src={n.logo}
            alt={n.name}
            loading="lazy"
            decoding="async"
            className={`${n.h} w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]`}
          />
        </a>
      ))}
    </div>
  </div>
);
